import {type CommitInfoPayload, CommitInfoPayloadSchema} from '@github-ui/dotcom-schema/types/repos/tree/v1/commit_info'
import {repositoryTreePath} from '@github-ui/paths'
import {QueryRouteQueryType} from '@github-ui/react-core/future/data-router-types'

import type {CodeViewPathParams} from './types/shared-query-types'

export const treeCommitInfoQuery = {
  queryName: 'treeCommitInfo' as const,
  queryDeps: ({params: routeParams}: {params: Record<string, string | undefined>}) => {
    const params = routeParams as CodeViewPathParams

    return {
      pathname: repositoryTreePath({
        repo: {
          ownerLogin: params.owner,
          name: params.repo,
        },
        commitish: params.branch,
        path: params['*'],
        action: 'tree-commit-info',
      }),
    }
  },
  schema: CommitInfoPayloadSchema,
  select: (data: CommitInfoPayload) => {
    return data.entries
  },
  type: QueryRouteQueryType.Deferred,
  persister: {
    enabled: true,
  },
}
